import adminElementEdit from './admin_element_edit'

export default function (state = {}, action) {
  return {
    adminElementEdit: adminElementEdit(state.adminElementEdit, action)
  }
}
